export class Helpers {
  static generateRandomString(): string {
    return Math.floor(Math.random() * Date.now()).toString(36);
  }

  static sumCharacterCodesWithIndex(str: string) {
    return Array.from(str).reduce((sum, char, index) => sum + char.charCodeAt(0) * (index + 1), 0);
  }

  static toBase36(num: number) {
    return num.toString(36);
  }
}
